import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { concatMap, from, of } from 'rxjs';
import { ApVendor } from 'src/app/classes/models';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { UnlinkApVendorsModalComponent } from 'src/app/modals/unlink-ap-vendors-modal/unlink-ap-vendors-modal.component';

import { ApVendorService } from '../ap-vendor.service';

@Injectable({
  providedIn: 'root'
})
export class ApVendorUtilityService {
  constructor(
    private ModalService: NgbModal,
    private ApVendorService: ApVendorService
  ) {}

  handleApAutolinkDisableModal(
    allowEinAutoLink: boolean,
    {
      CompanyId,
      VendorId,
      ExemptVendorId,
      ClientRegisteredVendorId
    }: {
      CompanyId: number;
      VendorId?: number;
      ExemptVendorId?: number;
      ClientRegisteredVendorId?: number;
    }
  ) {
    const ConfirmModal = this.ModalService.open(ConfirmModalComponent, {
      backdrop: 'static',
      modalDialogClass: 'confirm-modal'
    });

    Object.assign(ConfirmModal.componentInstance, {
      displayText: `Are you sure you want to ${allowEinAutoLink ? 'disable' : 'enable'} AP Vendor Auto Linking?`
    });

    return from(ConfirmModal.result).pipe(
      concatMap((response) => {
        if (response) {
          // Only display unlink modal if the Client/Vendor relationship is currently set
          // to auto-link AP Vendors.
          return (() => {
            if (allowEinAutoLink) {
              const { componentInstance, result } = this.ModalService.open(
                UnlinkApVendorsModalComponent,
                { backdrop: 'static', size: 'lg' }
              );

              Object.assign(componentInstance, {
                CompanyId,
                VendorId,
                ExemptVendorId,
                ClientRegisteredVendorId
              });

              return from<Promise<ApVendor[]>>(result).pipe(
                concatMap((ApVendors: ApVendor[]) =>
                  this.ApVendorService.saveApVendors(ApVendors)
                )
              );
            }

            return of<ApVendor[]>([]);
          })();
        }

        throw new Error('Confirmation cancelled.');
      })
    );
  }
}
